import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = { class: "dialog-footer" }
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { reactive, ref, unref } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';

import { GbDialog } from '@/components/GbDialog/Index';

/* Apis */
import { CtAgreeApi, CtRejectApi } from '../../../apis/contract/contract.api';

/* Dtos */
import { CtAuditDto } from '../../../apis/contract/contract.type';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const elFormRef = ref<ComponentRef<typeof ElForm>>()

const state = reactive({
    show: false,
    loading: false,
    title: '合同审批',
    detail: {} as any,
})

const formRules = reactive<FormRules>({
    remark: [{ required: true, message: '审核批示不能为空', trigger: 'blur' }],
})

const auditSchema = reactive<CtAuditDto>({
    id: '',
    revision: '',
    remark: ''
})

const btnActions = {
    /* 审批通过 */
    agree: () => {

        unref(elFormRef)?.validate(async (isValid: boolean) => {
            if (!isValid) return

            state.loading = true

            const formData = unref(auditSchema)
            const { succeeded, errors } = await CtAgreeApi(formData)

            if (!succeeded) {
                ElMessage.error(errors)
            }
            else {
                ElMessage.success("提交审批成功。")

                $emits('refresh', succeeded)
                state.show = false;
            }

            state.loading = false
        })

    },
}

/* 打开对话框 */
const showDialog = (contract: any) => {
    unref(auditSchema).id = contract.id
    unref(auditSchema).revision = contract.revision
    
    state.detail = contract
    state.show = true
}

expose({ showDialog })


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    style: {"width":"480px"}
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            style: {"width":"80px"},
            disabled: _unref(state).loading,
            onClick: btnActions.agree
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: _unref(auditSchema),
          "label-position": "top",
          rules: _unref(formRules),
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "合同编号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).detail.no) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "合同名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).detail.name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "审批意见",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(auditSchema).remark,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(auditSchema).remark) = $event)),
                  type: "textarea",
                  "show-word-limit": "",
                  rows: "6",
                  maxlength: "150",
                  placeholder: "请输入审批意见"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})